module.exports = "/images/vendor/flag-icon-css/flags/1x1/am.svg?c86a9e1691e7ab36234a070301467f01";